import React, { Component } from 'react';
import { Validator } from 'redux-form';

import { AppTextField } from 'components/form/appTextField';
import { AppFileField } from 'components/form/appFileField';
import { required } from 'components/form/formValidations';
import Button from 'components/buttons/button';
import { validateSnapcodeUrl, validateImg } from './Snapcode.utils';
import styles from './Snapcode.module.scss';

export class Snapcode extends Component<any> {
  private nameValidators: Validator[] = [];

  private urlValidators: Validator[] = [validateSnapcodeUrl];

  private imgValidators: Validator[] = [validateImg];

  constructor(props: any) {
    super(props);

    this.nameValidators = [...this.nameValidators, required];
    this.urlValidators = [...this.urlValidators, required];
    this.imgValidators = [...this.imgValidators, required];
  }

  render() {
    const { name, index, handleRemove, isDefault, id } = this.props;

    return (
      <div className={styles.wrapper}>
        <AppTextField name={`${name}.name`} label="Name" disabled={isDefault} validate={this.nameValidators} />
        <AppTextField
          className={styles.field}
          name={`${name}.url`}
          label="Snapchat barcode URL"
          validate={this.urlValidators}
        />
        <AppFileField
          name={`${name}.file`}
          label="Snapchat barcode Image"
          extensions={['png', 'svg']}
          validate={this.imgValidators}
        />
        {!!id && <AppTextField name={`${name}.id`} label="id" disabled />}
        {isDefault || <Button type="button" text="Remove" onClick={() => handleRemove(index)} />}
      </div>
    );
  }
}
